import { fetchData } from '../../Api';

export const getDataForRoute = async (url: string) => {
  const routes: Record<string, string> = {
    '': 'home',
    'termos-de-uso': 'termos',
    'politica-de-privacidade': 'politicas',
    'quem-somos': 'quem-somos',
    'seja-um-expositor': 'seja-um-expositor',
    'uniexpo-no-seu-colegio': 'uniexpo-no-seu-colegio',
  };

  if (routes[url]) {
    return await fetchData(routes[url]);
  }

  // Eventos Integra
  if (url.includes('agenda-de-eventos')) 
  {
    const params = url.split("/");

    if (params.length > 1) {
      return await fetchData(`eventos/${params[1]}`);
    }

    return await fetchData(`eventos`);
  }

  // Listagem de Blog
  if (url.includes('blog'))    
  {  
    const params = url.split("/");
    if (params.length > 1)
      return await fetchData(`noticias/${params[1]}`)    

    return await fetchData(`noticias?search=&page=1`)    
  }

  if (url.includes('palestra')) 
  {
    const params = url.split("/");

    if (params.length > 1) {
      return await fetchData(`palestra/${params[1]}`);
    }

    return await fetchData(`palestra`);
  }
  return undefined;
};